const api_url = process.env.REACT_APP_TASKER_API_URL;

//ForgotPassword.js
export function forgotPassword(data) {
  return fetch(api_url + "/api/v1/users/forgot_password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (res.status >= 200 && res.status <= 299) {
      return res.json();
    } else if (res.status === 400) {
      return res.json();
    } else {
      throw Error(res.statusText);
    }
  });
}

//ResetPassword.js
export function resetPassword(data) {
  return fetch(api_url + "/api/v1/users/reset_password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (res.status >= 200 && res.status <= 299) {
      return res.json();
    } else if (res.status === 400) {
      return res.json();
    } else {
      throw Error(res.statusText);
    }
  });
}

//DeleteAccount.js
export function deleteAccount(data) {
  return fetch(api_url + "/api/v1/users/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (res.status >= 200 && res.status <= 299) {
      return res.json();
    } else if (res.status === 400) {
      return res.json();
    } else {
      throw Error(res.statusText);
    }
  });
}
